import {Cards} from '/constant/TestIDs';
import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

export type Competency =
  | typeof BUSINESS_COACH
  | typeof BUSINESS_LEADER
  | typeof COACH;

export type ClientSummaryKeys = {
  newKey: string;
  newLabel: string;
  newTestID: string;
  newTitleTestID: string;
  totalKey: string;
  totalLabel: string;
  totalGenReactivatedKey: string;
  totalGenReactivatedLabel?: string;
  frontlineReactivatedKey: string;
  frontlineReactivatedLabel: string;
  totalTestID: string;
  totalTitleTestID: string;
};

const CLIENT_SUMMARY_CONFIG: Record<string, ClientSummaryKeys> = {
  [COACH]: {
    newKey: 'new.frontline',
    newLabel: 'New Frontline Clients',
    newTestID: Cards.cardNewFrontlineClientsValue,
    newTitleTestID: Cards.cardNewFrontlineClientsTitle,
    totalKey: 'total.frontline',
    totalLabel: 'All Frontline Clients',
    totalGenReactivatedKey: 'total.gen.reactivated',
    frontlineReactivatedKey: 'frontline.gen.reactivated',
    frontlineReactivatedLabel: 'Frontline Reactivated Clients',
    totalTestID: Cards.cardAllFrontlineClientsValue,
    totalTitleTestID: Cards.cardAllFrontlineClientsTitle,
  },

  [BUSINESS_COACH]: {
    newKey: 'new.gen0',
    newLabel: 'New Gen0 Clients',
    newTestID: Cards.cardNewGen0ClientsValue,
    newTitleTestID: Cards.cardNewGen0ClientsTitle,
    totalKey: 'total.gen0',
    totalLabel: 'Total Gen0 Clients',
    totalGenReactivatedKey: 'total.gen.reactivated',
    totalGenReactivatedLabel: 'TGen Reactivated Clients',
    frontlineReactivatedKey: 'frontline.gen.reactivated',
    frontlineReactivatedLabel: 'Frontline Reactivated Clients',
    totalTestID: Cards.cardTotalGen0ClientsValue,
    totalTitleTestID: Cards.cardTotalGen0ClientsTitle,
  },

  [BUSINESS_LEADER]: {
    newKey: 'new.org',
    newLabel: 'New TGen Clients',
    newTestID: Cards.cardNewTGenClientsValue,
    newTitleTestID: Cards.cardNewTGenClientsTitle,
    totalKey: 'total.org',
    totalLabel: 'All TGen Clients',
    totalGenReactivatedKey: 'total.gen.reactivated',
    totalGenReactivatedLabel: 'TGen Reactivated Clients',
    frontlineReactivatedKey: 'frontline.gen.reactivated',
    frontlineReactivatedLabel: 'Frontline Reactivated Clients',
    totalTestID: Cards.cardAllTGenClientsValue,
    totalTitleTestID: Cards.cardAllTGenClientsTitle,
  },
};

export function getClientSummaryKeys(
  currentUserCompetency: Competency,
): ClientSummaryKeys {
  const config = CLIENT_SUMMARY_CONFIG[currentUserCompetency];

  if (!config) {
    throw new Error(`Unsupported competency: ${currentUserCompetency}`);
  }

  return {
    ...config,
  };
}
